export default __webpack_public_path__ + "static/media/services-wellness.d8f607e6.jpg";